export const loginApiErrorsByStatuses = {
  "401": "Your email or password is incorrect. Please try again",
};
export const signUpApiErrorsByStatuses = {
  "422": "The email has already been taken.",
};
